export const documentsType = [
  { value: 'Assessment', label: 'Assessment' },
  { value: 'Summary', label: 'Summary' },
  { value: 'IEP Reports', label: 'IEP Reports' },
  { value: 'Other', label: 'Other' },
];

export const assessmentsType = [
  { value: 'Vineland Assessment', label: 'Vineland Assessment' },
  { value: 'Other', label: 'Other' },
]; 